module.exports = __webpack_public_path__ + "img/title.8b6ae624.png";